<div [formGroup]="form">
  <div class="form-group">
    <app-select-shareholder-form
      [formGroup]="form.controls.selectShareholder"
      [securityRegistryRecords]="transferSecurityRegistryRecords"
      [selectedIndividualShareholder]="selectedIndividualShareholder"
      [selectedCompanyShareholder]="selectedCompanyShareholder"
    />
  </div>

  <app-divider margin="24px 0"/>

  <div class="form-group share-numbers-grid big-left">
    <app-share-security-holdings-dropdown
      formControlName="securityHoldingId"
      [options]="securityRegistryRecordsHoldings"
    />

    <app-input-number
      label="Number of shares to be transferred"
      formControlName="numberOfSharesTransferred"
      [min]="0"
      [max]="this.selectedShareholderShareType?.number ?? 0"
      [customErrors]="totalNumberOfSharesCustomErrors"
    />
  </div>
</div>
